<script>
import SelectState from "@/components/_Shared/IBGE/States";
import SelectCity from "@/components/_Shared/IBGE/Cities";
import StepText from "@/components/SignUp/Steps/StepText";

import errorMixin from "@/mixins/errorMixin";
import { mapActions, mapState } from "vuex";

export default {
  mixins: [errorMixin],
  components: {
    SelectState,
    SelectCity,
    StepText
  },

  data() {
    return {
      street: "",
      street_number: "",
      complement: "",
      district: "",
      city: 0,
      state: 0,
      country: "BRA",
      zip_code: "",
      stateError: false,
      cityError: false
    };
  },

  computed: {
    ...mapState("signUp", [
      "legal_representative_address",
      "fieldErrors",
      "displayIBGESelects"
    ])
  },

  methods: {
    ...mapActions("signUp", [
      "nextLegalStep",
      "prevLegalStep",
      "setLegalRepresentativeAddress",
      "hideIBGESelects"
    ]),

    async submit() {
      try {
        await this.validate();
        this.nextLegalStep();
      } catch (e) {
        this.$toasted.error(e);
      }
    },

    async validate() {
      let dataIsValid = await this.$validator.validateAll();
      this.stateError = !this.state;
      this.cityError = this.state && !this.city;

      if (!dataIsValid || this.stateError || this.cityError)
        throw "Existem dados incorretos ou incompletos!";
    }
  },

  mounted() {
    document.querySelector("input").focus();
    this.inputErrors(this.fieldErrors);
    if (this.legal_representative_address)
      Object.assign(this.$data, this.legal_representative_address);
  },

  beforeDestroy() {
    let { stateError, cityError, ...data } = this.$data;
    this.setLegalRepresentativeAddress(data);
  },

  watch: {
    state(val) {
      if (val) this.stateError = false;
    },
    city(val) {
      if (val) this.cityError = false;
    },
    displayIBGESelects(val) {
      if (!val) {
        this.city = "";
        this.state = "";
      }
    }
  }
};
</script>

<template>
  <form @submit.prevent="submit()">
    <step-text>Agora precisamos saber o endereço do representante da empresa:</step-text>

    <base-input
      :error="errors.first('Rua')"
      v-validate="'required|max:255'"
      v-model="street"
      label="Rua"
    />

    <base-input
      :error="errors.first('Número')"
      v-validate="'required|numeric|max:31'"
      v-model="street_number"
      label="Número"
    />

    <base-input
      :error="errors.first('Complemento')"
      v-validate="'required|min:2|max:255'"
      v-model="complement"
      label="Complemento"
    />

    <base-input
      :error="errors.first('cep')"
      :masked="false"
      v-validate="'required|length:8'"
      v-model="zip_code"
      label="CEP"
      name="cep"
      data-vv-as="CEP"
      mask="#####-###"
    />

    <template v-if="displayIBGESelects">
      <select-state v-model="state" :value="state" :error="stateError" @error="hideIBGESelects()" />
      <select-city
        v-model="city"
        :value="city"
        :error="cityError"
        :state="state"
        @error="hideIBGESelects()"
      />
    </template>

    <template v-else>
      <base-input
        :error="errors.first('UF')"
        v-validate="'required|length:2'"
        v-model="state"
        label="UF"
      />

      <base-input
        :error="errors.first('Cidade')"
        v-validate="'required|min:2|max:255'"
        v-model="city"
        label="Cidade"
      />
    </template>

    <base-input
      :error="errors.first('Bairro')"
      v-validate="'required|min:2|max:45'"
      v-model="district"
      label="Bairro"
    />

    <base-flex justify="end" class="mt-10">
      <base-button @click="prevLegalStep()" outlined>voltar</base-button>
      <base-button type="submit">continuar</base-button>
    </base-flex>
  </form>
</template>



// WEBPACK FOOTER //
// src/components/SignUp/Steps/Accountable/Types/Legal/Address.vue